module.exports = __webpack_public_path__ + "img/banner-title-img.89e371af.png";